import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const WITHOUT = ['Improvisás la clase cada semana', 'Sobrecargás a unos y aburrís a otros', 'Perdés alumnos en temporada baja', 'No sabés cuándo derivar a un médico', 'Tu negocio no crece ni escala', 'Vendés sin método ni scripts'];
const WITH = ['Estructura lista para repetir', 'Una clase segura para todos los niveles', 'Sistema de retención todo el año', 'Protocolo claro de seguridad y riesgo', 'Ruta clara para escalar tu oferta', 'Scripts de venta que cierran planes'];
export function Comparison() {
  return <section className="px-5 py-10" data-id="element-39">
      <div className="mx-auto max-w-md" data-id="element-40">
        <h2 className="text-center font-anton text-xl leading-tight text-white sm:text-2xl" data-id="element-41">
          Sin Hyrox Definitivo 360 <span className="text-[#F5C518]" data-id="element-42">vs</span>{' '}
          Con Hyrox Definitivo 360
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2.5" data-id="element-43">
          {/* Without */}
          <div className="rounded-xl border border-red-500/30 bg-red-500/5 p-3" data-id="element-44">
            <h3 className="mb-3 flex items-center gap-1.5 font-oswald text-xs font-700 uppercase tracking-wide text-red-400" data-id="element-45">
              <XIcon className="h-4 w-4" data-id="element-46" /> Sin el sistema
            </h3>
            <ul className="space-y-2.5" data-id="element-47">
              {WITHOUT.map((t, i) => <li key={i} className="flex items-start gap-1.5 text-[12px] leading-tight text-neutral-300" data-id="element-48">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" data-id="element-49" />
                  <span data-id="element-50">{t}</span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="rounded-xl border border-[#F5C518]/40 bg-[#F5C518]/5 p-3" data-id="element-51">
            <h3 className="mb-3 flex items-center gap-1.5 font-oswald text-xs font-700 uppercase tracking-wide text-[#F5C518]" data-id="element-52">
              <CheckIcon className="h-4 w-4" data-id="element-53" /> Con el sistema
            </h3>
            <ul className="space-y-2.5" data-id="element-54">
              {WITH.map((t, i) => <li key={i} className="flex items-start gap-1.5 text-[12px] leading-tight text-white" data-id="element-55">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#F5C518]" data-id="element-56" />
                  <span data-id="element-57">{t}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}